import React, {Fragment} from "react";
import Modal from "../../../layout/Modal";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import Portal from "../../../layout/Portal";
import StockEditor from "../../stockEditor";
import Items from "./Items";
import ComponentLoader from "../../../form/ComponentLoader";
import OperationListStock from "../../OperationList/OperationListStock";
import {get} from "../../../../utils/dotutils";

const filterable = true;
const sortable = true;

export default class PosItems extends React.Component {

    state = {
        itemsToAdd: []
    };

    render() {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            return null;
        }
        const editableFields = this.props.values.state + "" === "50" ? ["id", "netsaleprice", "saleprice", "totalprice", "discount", "qty", "vat"] : (this.props.values.state + "" === "507" ? ["netsaleprice", "saleprice", "totalprice", "discount", "vat"] : []);
        if (this.props.values.pos) {
            return (
                <ComponentLoader
                    componentName="PointOfSale"
                    componentId={this.props.values.pos.id}
                    view={["partner"]}
                    dynamic={true}
                >
                    {(props) =>
                        <Fragment>
                            <Modal
                                ref={(addItemModal) => this.addItemModal = addItemModal}
                                size="large"
                                header="Termékek"
                                disabled={this.props.disabled || this.props.isLoading}
                                buttons={[
                                    {
                                        text: "Mégse",
                                        props: {
                                            color: "default",
                                            disabled: this.props.disabled || this.props.isLoading
                                        },
                                        onClose: true,
                                        onClick: async () => {
                                            try {
                                                this.setState({itemsToAdd: []});
                                                this.addItemModal && this.addItemModal.hide();
                                            } catch (e) {

                                            }
                                        }
                                    },
                                    {
                                        text: "Hozzáadás",
                                        props: {
                                            color: "primary",
                                            disabled: !this.state.itemsToAdd.length || this.props.disabled || this.props.isLoading
                                        },
                                        onClick: async () => {
                                            try {
                                                this.state.itemsToAdd.length && await this.addNewRows(this.state.itemsToAdd);
                                                this.setState({itemsToAdd: []});
                                                this.addItemModal && this.addItemModal.hide();
                                            } catch (e) {

                                            }
                                        }
                                    }
                                ]}
                            >
                                <SelectorGrid
                                    component="product"
                                    onItemUpdate={async (item, oldItem, field) => {
                                        if (parseInt(item.qty) > 0) {
                                            if (field === "discount") {
                                                item.discount = parseFloat(item.discount);
                                            }
                                            if (field === "saleprice") {
                                                item.saleprice = parseFloat(item.saleprice);
                                                item.discount = (100 - item.saleprice / item.listprice * 100).toFixed(2);
                                            }
                                            if (field === "discount") {
                                                item.saleprice = item.listprice - Math.round(item.listprice / 100 * item.discount);
                                            }
                                            let has = false;
                                            const itemsToAdd = this.state.itemsToAdd.map((_item) => {
                                                if (_item.id + "" === item.id) {
                                                    has = true;
                                                    return item;
                                                } else {
                                                    return _item;
                                                }
                                            });
                                            if (!has) {
                                                itemsToAdd.push(item);
                                            }
                                            this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                                        } else {
                                            const itemsToAdd = this.state.itemsToAdd.filter((_item) => {
                                                return _item.id + "" !== item.id;
                                            });
                                            this.setState({itemsToAdd: itemsToAdd.sort((a, b) => a.qty - b.qty)});
                                            delete item.qty;
                                        }
                                        return item;
                                    }}
                                    onSort={(field, direction) => {
                                        if (field === "qty" && !!this.state.itemsToAdd.length) {
                                            return {
                                                expression: "FIELD({{id}}, " + this.state.itemsToAdd.map((item) => item.id).join(", ") + ")",
                                                direction
                                            };
                                        }
                                    }}
                                    view={["vat"]}
                                    columns={{
                                        "displayname": {
                                            ...ProductColumn("product_id"),
                                            width: 6,
                                        },
                                        "category.name": {
                                            header: 'Árutípus',
                                            width: 1,
                                            sortable,
                                            filterable
                                        },
                                        "sku": {
                                            header: 'ISBN',
                                            width: 2,
                                            sortable,
                                            filterable
                                        },
                                        "listprice": {
                                            header: 'Fogyasztói ár',
                                            width: 2,
                                            sortable,
                                            filterable,
                                            renderer: CurrencyFormatter,
                                            className: "currency"
                                        },
                                        "qty": {
                                            header: 'Db',
                                            width: 1,
                                            sortable,
                                            renderer: (value, row) => UnitFormatter((this.state.itemsToAdd.find((item) => row.id + "" === "" + item.id) || {}).qty, row.unit),
                                            className: "unit",
                                            editor:
                                                (parent) =>
                                                    (props, value) =>
                                                        <TextInput type="number" name="qty" label={false} focus
                                                                   value={(this.state.itemsToAdd.find((item) => props.rowData.id + "" === "" + item.id) || {}).qty}
                                                                   onKeyDown={(e, field, value) => {
                                                                       ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                                   }}
                                                                   onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                        },
                                        "stock": {
                                            header: 'Készlet',
                                            renderer: (value, row) => {
                                                let stockList = null;
                                                return <OperationListStock productId={get(row, "product_id")} product={row}>
                                                    <a className="btn btn-block btn-default btn-xs">
                                                        Készlet
                                                    </a>
                                                </OperationListStock>;
                                                return <Fragment>
                                                    <a className="btn btn-block btn-default" onClick={(e) => {
                                                        e && e.preventDefault();
                                                        stockList && stockList.focus();
                                                    }}>
                                                        Készlet
                                                    </a>
                                                    <Portal>
                                                        <StockEditor
                                                            gridid={null}
                                                            list={
                                                                (props) =>
                                                                    <Modal
                                                                        size="large"
                                                                        ref={(e) => stockList = e}
                                                                        {...props}
                                                                        disabled={this.props.disabled || this.props.isLoading}
                                                                        buttons={[
                                                                            {
                                                                                text: "Bezárás",
                                                                                props: {
                                                                                    color: "default",
                                                                                    disabled: this.props.disabled || this.props.isLoading
                                                                                },
                                                                                onClose: true,
                                                                                onClick: async () => {
                                                                                    try {
                                                                                        stockList && stockList.hide();
                                                                                    } catch (e) {

                                                                                    }
                                                                                }
                                                                            }
                                                                        ]}/>
                                                            }
                                                            partner_id={props.PointOfSale.partner.partner_id}
                                                            product_id={row.id}
                                                        />
                                                    </Portal>
                                                </Fragment>;
                                            }
                                        }
                                    }}
                                />
                            </Modal>
                            <Items
                                PointOfSale={props.PointOfSale}
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                values={this.props.values}
                                addRowFunction={({event, addNewRows}) => {
                                    this.addNewRows = addNewRows;
                                    this.addItemModal && this.addItemModal.focus();
                                }}
                                editableFields={editableFields}
                            />
                        </Fragment>
                    }
                </ComponentLoader>
            );
        } else {
            return (
                <Items
                    getFieldProps={this.props.getFieldProps}
                    componentConfig={this.props.componentConfig}
                    values={this.props.values}
                    editableFields={editableFields}
                />
            );
        }
    }
}